import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { RoomsWidget } from './RoomsWidget'

class HoldstyringRoomsElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return RoomsWidget
  }

  // Supported HTML attributes:
  //   title="Vores lokaler"  — heading above the cards (default: none)
  //   show-features="false"  — hide features/equipment tags (default: visible)
  protected getWidgetProps() {
    return {
      title: this.getAttribute('title') || null,
      showFeatures: this.getAttribute('show-features') !== 'false',
    }
  }
}

if (!customElements.get('holdstyring-rooms')) {
  customElements.define('holdstyring-rooms', HoldstyringRoomsElement)
}

export { HoldstyringRoomsElement }
